module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_11.4464e572.jpg";